import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  setItem(key: string, value?: any, ttlMinutes?: number) {
    if (typeof localStorage === 'undefined') {
      console.warn('localStorage is not available');

      return;
    }
    if (!value) {
      return;
    }

    const now = new Date();
    const ttlMilliseconds = ttlMinutes ? ttlMinutes * 60 * 1000 : null;

    const item = {
      value: value,
      expiry: ttlMilliseconds ? now.getTime() + ttlMilliseconds : null,
    };

    localStorage.setItem(key, JSON.stringify(item));
  }

  getItem<T>(key: string): T | null {
    if (typeof localStorage === 'undefined') {
      console.warn('localStorage is not available');

      return null;
    }

    const itemStr = localStorage.getItem(key);

    if (!itemStr) {
      return null;
    }

    const item = JSON.parse(itemStr);
    const now = new Date();

    if (item.expiry && now.getTime() > item.expiry) {
      localStorage.removeItem(key);

      return null;
    }

    return item.value;
  }

  removeItem(key: string): void {
    if (typeof localStorage === 'undefined') {
      console.warn('localStorage is not available');

      return;
    }

    localStorage.removeItem(key);
  }
}
